import Isotope from 'isotope-layout/dist/isotope.pkgd.min.js';

import 'Sass/views/career-guide.scss';

(function () {
    'use strict';

    const container = document.querySelector('.masonry-outer');
    const search = document.querySelector('.career-search');
    const h5 = container.querySelectorAll('h5');
    const filterLinks = document.querySelectorAll('[data-filter]');

    const options = {
        itemSelector: '.masonry-object',
        transitionDuration: 'ontouchstart' in window ? 0 : '0.2s'
    };

    const iso = new Isotope(container, options);

    // trigger isotope layout for keyword
    const filterIsotope = filterTerm => {
        iso.arrange({
            filter: function () {
                return filterTerm ? this.querySelector('h5').innerText.match(filterTerm) : true;
            }
        });
    }

    // debounce so filtering doesn't happen every millisecond
    const debounce = (fn, threshold) => {
        var timeout;
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }

            const delayed = () => {
                fn();
                timeout = null;
            }

            timeout = setTimeout(delayed, threshold || 100);
        };
    }

    for (let link of filterLinks) {
        link.addEventListener('click',
            () => {
                angular.element(filterLinks).removeClass('active');

                var filterValue = link.getAttribute('data-filter');
                filterValue === '*' ? angular.element(h5).removeClass('open') : link.classList.add('active');

                search.value = '';
                iso.arrange({ filter: filterValue, sortBy: 'original-order' });
            });
    }

    for (let h of h5) {
        h.addEventListener('click',
            () => {
                h.parentElement.classList.toggle('open');
                iso.layout();
            });
    }

    // use value of search field to filter       
    search.addEventListener('keyup',
        debounce(() => {
            angular.element(document.querySelector('.filter-button')).removeClass('active');

            const text = search.value.trim();
            text ? filterIsotope(new RegExp(search.value, 'gi')) : filterIsotope();

        }, 100));

    // ensure search field doesn't trigger modal search
    angular.element(document.querySelector('.career-search'))
        .on('focus', () => document.body.classList.add('input-focus'))
        .on('blur', () => document.body.classList.remove('input-focus'));

})();
